/** @format */

import React, { useEffect, useRef, useState } from "react";
import { Input } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { ExcelPrint, PrintElem } from "../../../../components/functions/Print";
import print from "../../../../icons/print.png";
import { NavLink } from "react-router-dom";
import pdf from "../../../../icons/pdf.png";
import excel from "../../../../icons/excel.png";
import axios from "axios";
import { header } from "../../../../components/api/Header";
import $ from "jquery";
import Card from "../../../../components/Card";
import Minimap from "../../../../components/map/Minimap";
import Chart2 from "../../../../components/Charts/Chart2";
import { useReactToPrint } from "react-to-print";
import LoadingCard from "../../../../components/loading/loadingCard";
import { getEnv } from "../../../../lib/env";

function Yillik({ region, vaqt, search, havza }) {
  const conponentPDF = useRef();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState("");

  const [year, setYear] = useState(new Date().toISOString().slice(0, 4));
  const [lyear, setLyear] = useState(year);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          getEnv('REACT_APP_BASE_URL') +
            "/v1/region/asosiymanbalar/yillik?year=" +
            year +
            "&vaqt=" +
            vaqt +
            "&havza=" +
            havza,
          header()
        );

        if (res && res.data) {
          if (region === "Gidromet" && havza === 1) {
            setData(res.data.slice(23, 48).concat(res.data.slice(59, 63)));
          } else if (region === "Gidromet" && havza === 2) {
            setData(
              res.data
                .slice(0, 23)
                .concat(res.data.slice(31, 35), res.data.slice(48, 59))
            );
          } else {
            setData(res.data);
          }
        }
      } catch (e) {
        console.log("Xato", e);
        alert("Serverga ulanishda xato!");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [year, vaqt, havza]);

  useEffect(() => {
    setYear(lyear);
  }, [lyear]);

  const chiz = (index) => {
    removeChecked();
    let v = $("tr.tr" + index + " input");
    let checked = v[0].checked;
    v[0].checked = !checked;
    if (!checked) {
      $("tr.tr" + index).addClass("active");
    } else {
      $("tr.tr" + index).removeClass("active");
    }
    setSelectedRowKeys(index);
  };

  const removeChecked = () => {
    if (selectedRowKeys !== "") {
      $("tr.tr" + selectedRowKeys + " input")[0].checked = false;
      $("tr.tr" + selectedRowKeys).removeClass("active");
    }
  };

  const close = () => {
    if (selectedRowKeys !== "") {
      $("tr.tr" + selectedRowKeys + " input")[0].checked = false;
      $("tr.tr" + selectedRowKeys).removeClass("active");
    }
    setSelectedRowKeys("");
  };

  const labels = [year, year - 1, year - 2, year - 3, year - 4];

  const generatePDF = useReactToPrint({
    content: () => conponentPDF.current,
    documentTitle: "Asosiy manbalar",
  });

  return (
    <>
      <div className='table-box'>
        <div className='table-content-top'>
          <div className='table-top-left'>
            <Input
              prefix={<SearchOutlined className='site-form-item-icon' />}
              placeholder='Search'
              onChange={(e) => search(e.target.value)}
            />
          </div>

          <ul className='table-top-right'>
            <li>
              <div className='d-flex'>
                <input
                  type='number'
                  className='form-control form-control-sm'
                  value={lyear}
                  onChange={(e) => setLyear(e.target.value)}
                />
              </div>
            </li>

            <li>
              <button className='btn p-0' onClick={() => generatePDF(".table")}>
                <img src={print} alt='404' />
              </button>
            </li>

            <li>
              <button
                className='btn p-0'
                onClick={() =>
                  ExcelPrint("Asosiy manbalar " + region, year, "tblData")
                }>
                <img src={excel} alt='404' />
              </button>
            </li>
          </ul>
        </div>

        {loading ? (
          <LoadingCard loading={loading} heightSize='80vh' />
        ) : (
          <div id='content'>
            <div
              id='tableFlexible'
              style={{ height: selectedRowKeys === "" ? "80vh" : "38vh" }}>
              <div ref={conponentPDF} style={{ width: "100%" }}>
                <table
                  id='tblData'
                  className='table table-bordered table-style fixedHeader'>
                  <thead className=''>
                    <tr>
                      <th className='sticky st1'>o</th>

                      <th className='sticky' style={{ left: "31px" }}>
                        T/R
                      </th>

                      <th
                        className='sticky'
                        style={{ left: "71px", width: "250px" }}>
                        Irrigatsiya tizimlari nomi va asosiy suvolish nuqtalari
                      </th>

                      <th className='sticky' style={{ left: "368px" }}>
                        O’lchov birligi
                      </th>

                      <th className='text-center'>{year}</th>

                      <th className='text-center'>{year - 1}</th>

                      <th className='text-center'>{year - 2}</th>

                      <th className='text-center'>{year - 3}</th>

                      <th className='text-center'>{year - 4}</th>
                    </tr>
                  </thead>

                  {data.length > 0
                    ? data.map((d, index) => {
                        return (
                          <tbody key={index}>
                            <tr
                              onClick={() => chiz(index)}
                              className={"tr tr" + index}>
                              <td
                                className='sticky st1'
                                style={{
                                  width: "40px",
                                  maxWidth: "40px",
                                  minWidth: "40px",
                                }}>
                                <input type='checkbox' />
                              </td>

                              <td
                                className='sticky'
                                style={{
                                  left: "31px",
                                  width: "40px",
                                  maxWidth: "40px",
                                  minWidth: "40px",
                                }}>
                                {index + 1}
                              </td>

                              <td
                                className='text-start sticky fix-with'
                                style={{
                                  left: "71px",
                                }}>
                                {d.manba_nomi}
                              </td>

                              <td
                                className='text-start sticky'
                                style={{
                                  left: "368px",
                                  width: "40px",
                                  maxWidth: "40px",
                                  minWidth: "40px",
                                }}>
                                {d.birligi}
                              </td>

                              {d.data
                                ? d.data.map((s, i) => {
                                    return (
                                      <td
                                        style={{
                                          width: "120px",
                                          maxWidth: "120px",
                                          minWidth: "120px",
                                        }}
                                        key={i}>
                                        {s}
                                      </td>
                                    );
                                  })
                                : Array(5)
                                    .fill()
                                    .map((i) => {
                                      return (
                                        <td
                                          style={{
                                            width: "120px",
                                            maxWidth: "120px",
                                            minWidth: "120px",
                                          }}
                                          key={i}></td>
                                      );
                                    })}
                            </tr>
                          </tbody>
                        );
                      })
                    : null}
                </table>
              </div>
            </div>
          </div>
        )}
      </div>

      {selectedRowKeys.length === 0 ? null : (
        <div
          className='data-content mt-3 mainpage'
          style={{ position: "relative" }}>
          <CloseOutlined
            style={{
              position: "absolute",
              top: 0,
              right: 10,
              zIndex: 9,
              fontSize: "20px",
              cursor: "pointer",
            }}
            onClick={close}
          />

          <Card>
            {data[selectedRowKeys].lat !== null &&
            data[selectedRowKeys].lan !== null ? (
              <Minimap
                location={[
                  data[selectedRowKeys].lat,
                  data[selectedRowKeys].lan,
                ]}
                locations={[]}
                zoom={13}
              />
            ) : null}
          </Card>

          <Chart2 datas={data[selectedRowKeys]["data"]} labels={labels} />
        </div>
      )}
    </>
  );
}

export default Yillik;
